import React from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Radio from '../../../components/atoms/radio/radio'
import { pushDataLayerEvent } from '../../../utils/metricManagementUtil'
import './radio-mark-card.scss'

const RadioMarkCard = ({
	description,
	step = 99,
	title,
	setActive,
	isActive,
	isReadOnly,
	image,
}) => {
	const dataLayerRegistro = (step, option) => {
		const location = typeof window === 'undefined' ? '' : window.location.href
		pushDataLayerEvent({
			event: 'Interacciones - Registro',
			category: step,
			action: 'click',
			label: option,
			location,
		})
	}

	const stepMapping = {
		1: 'registro_1',
		2: 'registro_2',
	}

	const handleDataLayerRegistro = () => {
		const category = stepMapping[step]
		if (category) {
			dataLayerRegistro(category, title)
		}
	}

	const handleClick = e => {
		e.preventDefault()
		handleDataLayerRegistro()
		setActive()
	}

	return (
		<button
			onClick={handleClick}
			className={`f-mark-card ${isActive ? 'f-mark-card--active' : ''} ${
				isReadOnly ? 'f-mark-card--disabled' : ''
			}`}
		>
			<div className='f-mark-card-header'>
				<div className='f-radio-wrapper'>
					<Radio setActive={setActive} isActive={isActive} />
				</div>
			</div>
			<div className='f-mark-card-body'>
				<div className='f-mark-card-body-title'>
					<img
						src={image?.file.url}
						alt={image?.description || 'Card image'}
						className='f-image'
					/>
					<p>{title}</p>
				</div>
				<div className='f-mark-card-body-description'>
					{typeof description === 'string'
						? description
						: documentToReactComponents(JSON.parse(description.raw))}
				</div>
			</div>
		</button>
	)
}

export default RadioMarkCard
